import axios from '../localAxios';
import { workspaceMembersURL } from './workspacesURLs';

export interface WorkspaceMembersPage {
  members: WorkspaceMember[];
  limits: {
    maxEditors: number;
    maxViewers: number;
  } | null;
  nextCursor: string | null;
}

export interface WorkspaceMember {
  id: string;
  role: WorkspaceRole;
  status: WorkspaceMemberStatus;
  joinDate: string;
  fullName: string;
  email: string;
}

export enum WorkspaceRole {
  Owner = 3726,
  Editor = 1920,
  Viewer = 2834,
  Admin = 4517,
}

export enum WorkspaceMemberStatus {
  Inactive = 9826,
  Active = 8162,
}

export type MembersSortBy = 'role' | 'name' | 'email';
export type MembersSortDir = 'asc' | 'desc';

export interface GetWorkspaceMembersParams {
  cursor?: string;
  limit?: number;
  sortBy?: MembersSortBy;
  sortDir?: MembersSortDir;
  search?: string;
}

export async function getWorkspaceMembers(
  workspaceId: string,
  { cursor, limit, sortBy, sortDir, search }: GetWorkspaceMembersParams = {}
): Promise<WorkspaceMembersPage> {
  const url = workspaceMembersURL(workspaceId);
  if (cursor) url.searchParams.set('cursor', cursor);
  if (limit !== undefined) url.searchParams.set('limit', String(limit));
  if (sortBy) url.searchParams.set('sortBy', sortBy);
  if (sortDir) url.searchParams.set('sortDir', sortDir);
  if (search) url.searchParams.set('search', search);
  const response = await axios.get<WorkspaceMembersPage>(url.href);
  return response.data;
}
